import React, { SVGProps } from 'react';

const UserAvatarIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.3639 5.63604C21.8787 9.15076 21.8787 14.8492 18.3639 18.3639C14.8492 21.8787 9.15074 21.8787 5.63604 18.3639C2.12132 14.8492 2.12132 9.15074 5.63604 5.63604C9.15076 2.12132 14.8492 2.12132 18.3639 5.63604"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13.9896 8.3239C15.0881 9.42244 15.0881 11.2035 13.9896 12.3021C12.891 13.4006 11.1099 13.4006 10.0114 12.3021C8.91287 11.2035 8.91287 9.42244 10.0114 8.3239C11.1099 7.22537 12.891 7.22537 13.9896 8.3239"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M17.707 18.958C16.272 17.447 14.248 16.5 12 16.5C9.75197 16.5 7.72797 17.447 6.29297 18.959"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default UserAvatarIcon;
